import { createSelector } from 'reselect';

import getSelectedOffer, { $getSelectedOffer } from './getSelectedOffer';
import getOrderTotals, { $getOrderTotals } from './getOrderTotals';
import getCouponMinimumSpendingInclusive from './getCouponMinimumSpendingInclusive';
import getSelectedOfferValid from './getSelectedOfferValid';
import { OFFER_TYPE } from '../constants/offerType';

const get = (
  selectedOffer: Offer | undefined,
  orderTotals: OrderTotals | undefined,
  isOfferValid: boolean | undefined,
  couponDiscountInclusive: boolean,
): number => {
  if (
    orderTotals === undefined ||
    !isOfferValid ||
    !selectedOffer ||
    !selectedOffer.MinOrderValue
  ) {
    return 0;
  }

  const { purchasesMoneyPrice, discountedMoneyPrice, surchargesMoneyPrice } =
    orderTotals;
  const discountedPrice = couponDiscountInclusive
    ? discountedMoneyPrice - surchargesMoneyPrice
    : purchasesMoneyPrice;
  let minDiff = selectedOffer.MinOrderValue * 100 - discountedPrice;
  if (
    selectedOffer.type === OFFER_TYPE.PERCENTAGE_OFF_ORDER &&
    selectedOffer.amount < 100 &&
    couponDiscountInclusive
  ) {
    minDiff = Math.ceil(minDiff / ((100 - selectedOffer.amount) / 100));
  }
  return Math.max(0, minDiff);
};

export default createSelector(
  [
    getSelectedOffer,
    getOrderTotals,
    getSelectedOfferValid,
    getCouponMinimumSpendingInclusive,
  ],
  get,
);

export const $getSelectedOfferMiniValueValid = createSelector(
  [
    $getSelectedOffer,
    $getOrderTotals,
    getSelectedOfferValid,
    getCouponMinimumSpendingInclusive,
  ],
  get,
);
